export const userPoolId = process.env.REACT_APP_USER_POOL_ID;
export const clientId = process.env.REACT_APP_CLIENT_ID;
export const uploadUrl = process.env.REACT_APP_SOAC_ASSET_UPLOAD_URL;
export const apiUrl = process.env.REACT_APP_SOAC_API_URL;
export const authUrl = process.env.REACT_APP_SOAC_AUTH_URL;
export const successfulAuthRedirectUrl = process.env.REACT_APP_SOAC_AUTH_REDIRECT_URL;
export const loginUrl = `${authUrl}/login?client_id=${clientId}&response_type=token&scope=aws.cognito.signin.user.admin&redirect_uri=${successfulAuthRedirectUrl}`;
export const logoutUrl = `${authUrl}/logout?client_id=${clientId}&response_type=token&scope=aws.cognito.signin.user.admin&logout_uri=${successfulAuthRedirectUrl}?logout=true`;
